import React from 'react';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import SMBadgeView from 'components/shared/SMBadgeView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRestClient from 'lib/SMRestClient';
import update from 'react-addons-update';
import sprintf from 'sprintf';
import SMServiceMessageListView from 'components/notifications/SMServiceMessageListView';
import SMToDoListView from 'components/notifications/SMToDoListView';
import SMNotificationListView from 'components/notifications/SMNotificationListView';

class SMNewsListView extends React.Component {

  constructor(props) {
    super(props);
    this.currentPage = this.props.page;
    this.canRequest = true;
    this.state = {
      badgeNumber: null,
      display: this.props.display,
      notificationItems: [],
      announcementItems: [],
      todoItems: [],
    };
  }

  componentDidMount() {
    this.spinnerRadius = 10;
    this.spinnerStrokeWidth = 2;
    $(document).on("SMHideBaloon", this.hideNotificationList.bind(this));
    if (!SMAppHelper.isMobile()) {
      this.setBadgeNumber();
    }
  }

  componentWillUnmount() {
    $(document).off("SMHideBaloon", this.hideNotificationList.bind(this));
  }

  componentWillUpdate(nextProps, nextState) {
    $(this.refs.tableView).off("scroll", this.tableViewDidScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    $(this.refs.tableView).on("scroll", this.tableViewDidScroll);
  }

  tableViewDidScroll(e){
    SMAppHelper.observeScrollToBottom(e.currentTarget, ()=>{
      this.requestNotificationResource(true);
    });
  }

  setBadgeNumber(){
    if (!this.props.currentUser) return null;
    SMUserResource.getNotifications(this.props.currentUser.username, {per_page:1, filter: "unread"}, (responses, error, xhr)=>{
      let number = xhr.getResponseHeader('X-List-Total-Count');
      let state = {
        badgeNumber: responses.unckecked_notifications_number,
        todoItems: responses.todo_items,
        announcementItems: responses.announcements,
      };
      this.setState(state);
      this.setTitleWithUnread();
    });
  }

  requestNotificationResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});
    let queries = {},
        responseHandler = (responses, error, xhr)=>{
          if(this.state.display == SMConst.Display.Hidden) return;
          this.setState({display: SMConst.Display.Visible});
          if(error || !responses) return;
          let links = SMRestClient.getLinks(xhr),
              notificationItems = this.state.notificationItems;
          if (links["next"]) {
            this.canRequest = true;
          }

          if (isAppend) {
            notificationItems = update(notificationItems, {$push: responses.notifications});
          } else {
            notificationItems = responses.notifications;
          }

          this.currentPage++;
          this.setState({
            badgeNumber: responses.unckecked_notifications_number,
            notificationItems: notificationItems,
            todoItems: responses.todo_items,
            announcementItems: responses.announcements,
          });
        };
    if (this.currentPage != 1) queries["page"] = this.currentPage;

    if (this.state.badgeNumber > 0) {
      SMUserResource.checkNotifications(this.props.currentUser.username, queries, responseHandler);
    } else {
      SMUserResource.getNotifications(this.props.currentUser.username, queries, responseHandler);
    }
  }

  setTitleWithUnread(){
    let label = SMFormatHelper.unreadNumberLabel(this.state.badgeNumber);
    if (label) {
      window.document.title = sprintf("(%s) %s", label, window.document.title);
    }
  }

  showNotificationList(e) {
    $(document).trigger("SMHideBaloon");
    this.currentPage = 1;
    this.canRequest = true;
    this.requestNotificationResource();
  }

  hideNotificationList(e) {
    this.setState({display: SMConst.Display.Hidden});
  }

  toggleNotificationList(e){
    e.stopPropagation();
    e.preventDefault();
    if (this.state.display == SMConst.Display.Hidden) {
      this.showNotificationList(e);
    } else {
      this.hideNotificationList(e);
    }
  }

  render() {
    let style = {
      display: (this.state.display == SMConst.Display.Hidden) ? "none" : ""
    };

    return(
      <li>
        <a onClick={this.toggleNotificationList.bind(this)} href="#" className="site-header__nav-message">
          <i className="fa fa-envelope"></i>
          <SMBadgeView 
            hasAnnouncements={(this.state.announcementItems.length > 0)}
            hasTodo={(this.state.todoItems.length > 0)}
            badgeNumber={this.state.badgeNumber} />
        </a>
        <div style={style} className="baloon baloon-top site-header__nav-baloon site-header__nav-baloon-message">
          <div ref="tableView" className="baloon-inner">
            <SMServiceMessageListView notifications={this.state.announcementItems} />
            <SMToDoListView notifications={this.state.todoItems} />
            <SMNotificationListView notifications={this.state.notificationItems} display={this.state.display} currentUser={this.props.currentUser} />
          </div>
        </div>
      </li>
    );
  }
}

SMNewsListView.defaultProps = {
  display: SMConst.Display.Hidden,
  page: 1,
  perPage: 20
};
export default SMNewsListView;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMNewsListView.jsx